import { Box, Button, Text } from "@chakra-ui/react";
import { BookCard } from "../../components/Book/BookCard";

const BookSuccessPage = () => {
  return (
    <Box bg={"#F9F9F9"}>
      <Box height={"100vh"} px={{ base: 4, lg: 0 }}>
        <BookCard mt={{ base: 4, lg: "60px" }} mx="auto">
          <Box textAlign={"center"}>
            <Box fontSize={"86px"} lineHeight={1} color={"#30CA3C"}>
              <i
                className="ri-checkbox-circle-fill"
                style={{ lineHeight: 1 }}
              ></i>
            </Box>

            <Text
              fontSize="lg"
              fontWeight="700"
              fontFamily="Cairo"
              lineHeight="35px"
              color="#202020"
            >
              Booking Successful
            </Text>
            <Text
              maxW={"600px"}
              mx="auto"
              fontFamily={"Open Sans"}
              color="#A5A5A5"
            >
              Check your email for details. If you need any help, contact{" "}
              <a href="mailto:support@makerkids.com">
                <Text display={"inline"} color="#27489B" fontWeight={700}>
                  support@makerkids.com
                </Text>
              </a>
              . Thank you.
            </Text>
          </Box>

          <Button
            colorScheme={"blue"}
            display={"flex"}
            alignItems="center"
            width={"full"}
            rounded="12px"
            h={"44px"}
            fontSize={"sm"}
            fontFamily="Cairo"
            border={"none"}
            mt="12"
            boxShadow={"0px 1px 2px rgba(31, 41, 55, 0.08)"}
          >
            <i className="ri-calendar-line"></i>{" "}
            <Text ml={2}>Add to the calendar</Text>
          </Button>
        </BookCard>
      </Box>
    </Box>
  );
};

export { BookSuccessPage };
